module.exports = __webpack_public_path__ + "img/dots.f1404970.svg";